export default __webpack_public_path__ + "static/media/youtubeClone_1.e02c390f.png";